import TransactionTransferOldCardCash from './TransactionTransferOldCardCash';

export default TransactionTransferOldCardCash;
